<script setup>
    import { ElCollapseItem, ElInput, ElSelect, ElOption } from 'element-plus';
    import { ref } from 'vue';
    import { storeToRefs } from 'pinia';
    import { useProductStore } from '../../../stores/fpe';
    import { ArrowRightBold } from '@element-plus/icons-vue'

    const store = useProductStore();
    const { product, data_sets, strings, selectedVariationDetails } = storeToRefs(store);

    const isShippingApplicable = ref(false);
    if(selectedVariationDetails.value.type == 'simple' || selectedVariationDetails.value.type == 'variable'){

        // check if simple product is virtual
        if((selectedVariationDetails.value.type == 'simple' || selectedVariationDetails.value.type == 'variable') && selectedVariationDetails.value.virtual == true){
            isShippingApplicable.value = false;
        }else{
            isShippingApplicable.value = true;
        } 
    }

</script>

<template>
    <el-collapse-item  :title="strings.section_title_shipping" class="fpe-section-shipping" name="variation-shipping" :icon="ArrowRightBold">
        <div class="fpe-field-wrapper" data-field="weight">
            <label>{{ strings.label_weight }}</label>
            <ElInput v-model="selectedVariationDetails.weight" />
        </div>

        <div class="fpe-field-wrapper fpe-dimensions" data-field="dimensions">
            <label>{{ strings.label_dimensions }}
                <Info :tooltip_text="strings.tooltip_dimensions" />
            </label>
            <div class="fpe-dimension-fields">
                <ElInput v-model="selectedVariationDetails.length" />
                <ElInput v-model="selectedVariationDetails.width" />
                <ElInput v-model="selectedVariationDetails.height" />
            </div>
        </div>

        <div class="fpe-field-wrapper" data-field="shipping-class">
            <label>{{ strings.label_shipping_class }}</label>
            <ElSelect v-model="selectedVariationDetails.shipping_class_id">
                <ElOption
                    v-for="(value, name) in Object.entries(data_sets.shipping_classes)"
                    :key="value[0]"
                    :label="value[1]"
                    :value="value[0]"
                />
            </ElSelect>
        </div>

    </el-collapse-item>    

</template>